import React, { Component } from "react";
import { Button, ControlLabel, Modal, ListGroup, ListGroupItem } from "react-bootstrap";
import uniqueId                       from 'lodash/uniqueId';
import LoaderButton                   from "../../components/LoaderButton";
import { Colors }                     from "../../utils/Colors";
import { invokeGetSingleBlockTemplate,
         invokeDeleteBlockTemplate,
         invokeEditNameBlockTemplate,
         invokeGetSearchAllBlockTemplates,
         invokeGetBlockTemplateList } from '../../utils/AwsInvoke';
import "../../css/modal/ModalAddBlockTemplate.css";

export default class ModalAddBlockTemplate extends Component {

    constructor(props) {
        super(props);

        var block_name = this.props.block_name
        if(this.props.block_name === null) block_name = "";

        this.state = {
            block_arr: [],
            block_name: "",
            searchTerm: "",
            error_msg: ""
        };
    }


    componentDidMount() {
        this.getBlockTemplateList();
    }

    async getBlockTemplateList () {
        const results = await invokeGetBlockTemplateList();

        if(results.status) {
            var block_arr = [];
            var lgth = results.data.length;

            for(var i=0; i < lgth; i++) {
                var name = results.data[i].name;
                var block_id = results.data[i].block_id;
                block_arr.push([name, block_id])
            }

            this.setState({
                block_arr: block_arr
            })
        }
    }


    /*handleSubmit = async event => {
        this.setState({
            isLoading: true
        })
        var block_id    = this.state.block_id;
        this.props.handleSubmitModalAddBlockTemplate(block_id);
    }*/

    handleCustomChange(event) {
        var text = event.target.value;

        this.setState({
            searchTerm: text
        })
    }


    handleKeyPress = (target) => {
        // Allow user to hit "Enter" when using Search box //
         if(target.charCode === 13)
            this.searchExercises();
    }

    handleEditNameBlockTemplate = async (block_name, block_id) => {
        this.props.handleOpenModalEditBlockName(block_name, block_id);
    }

    handleDeleteBlockTemplate = async (block_id) => {
        this.setState({
            error_msg: "Deleting block..."
        })
        const results = await invokeDeleteBlockTemplate(block_id);

        if(results.status) {
            this.getBlockTemplateList();
            this.setState({
                error_msg: "The block was deleted."
            })
        } else
            this.setState({
                error_msg: "Ooops, looks like there was an error. Try again."
            })
    }

    async handleSelectBlockTemplate (block_id) {
        this.setState({
            error_msg: "Loading the block template ..."
        })

        this.props.handleAddBlockTemplateToProgram(block_id);
        /*const results = await invokeGetSingleBlockTemplate(block_id);

        if(results.status) {

            var block_template = results["results"].single_block;
            this.props.handleAddBlockTemplateToProgram(block_template);
            // Close Modal //
            this.props.onHide();
        } else
            this.setState({
                activeListItem: "",
                error_msg: "Ooops, looks like there was an error. Try again."
            })*/
    }

    searchExercises = async () => {
        var search_term = this.state.searchTerm;
        const results = await invokeGetSearchAllBlockTemplates(search_term.toLowerCase());

        if(results) {
            var block_arr = [];
            var lgth = results.name.length;

            for(var i=0; i < lgth; i++) {
                var name     = results.name[i];
                var block_id = results.block_id[i];
                block_arr.push([name, block_id])
            }

            this.setState({
                block_arr: block_arr,
                searchTerm: search_term,
                //searchMsg: "You have "+results.search_lgth+ " results when searching for '" + search_term + "'.",
                isLoading: false,
                showLoadingBar: "none"
            });
        } else {
            this.setState({
                isLoading: false,
                showLoadingBar: "none"
            });
        }
    }

    renderBlockList (tmp_arr) {
        var list = tmp_arr.map(name => {
                           return <div key={uniqueId()}
                                       className="addBlockTemplateContainer">
                                        <span onClick={() => this.handleSelectBlockTemplate(name[1])}
                                              className = {"singleItemBlockTemplateFromList "}>
                                            { name[0] }
                                        </span>
                                        <span className="editNameBlockTemplateFromList"
                                            onClick={() => this.handleEditNameBlockTemplate(name[0], name[1])}>edit
                                        </span>
                                        <span className="deleteBlockTemplateFromList"
                                            onClick={() => this.handleDeleteBlockTemplate(name[1])}>delete
                                        </span>
                                  </div>
                        }
                    )
        if(tmp_arr.length == 0) list = <div><br/> &nbsp; You have <b>0</b> block templates.</div>

        return <ListGroup style={{display: "inline-block", height:"100px", width:"100%", overflowY:"none", border: "0px solid #000" }}>
                    { list }
                </ListGroup>
    }

    render() {
        var block_arr = this.state.block_arr;
        return (
            <Modal
                show      = {this.props.show}
                onHide    = {this.props.onHide}
                className = ""
              >
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title" className="fontSize26px">Add Block Template</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div>
                      &nbsp; Select a block template from your list below.
                      <br/><br/>
                      <div className="formLabelBody">Select a Block Template</div>
                      <input type="text"
                             placeholder = "Search Blocks"
                             value     = {this.state.searchTerm}
                             onChange  = {this.handleCustomChange.bind(this)}
                             onKeyPress={this.handleKeyPress}
                             className = "input-lg blockNameField" />

                         <Button className="searchBlockTemplateBtn"
                          onClick={() => this.searchExercises()}>
                          Search
                      </Button>

                      <br/><br/>
                      &nbsp; Saved Block Templates:

                      { this.renderBlockList(block_arr) }

                      <br/>
                  </div>
                  <div style={{color: "red", position:"relative", top:22}}>
                      &nbsp; { this.state.error_msg }
                  </div>
                  <br/>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="modalBasicsBtnClose" onClick={this.props.onHide}>Cancel</Button>
                    <span className="modalBasicsFooterXPosSpacer"/>
                    { /*}<Button className="modalButtonOk" bsStyle="primary" onClick={() => this.handleCloseWin("delete")}>Ok</Button>*/ }
                    { /*}<LoaderButton
                        bsSize    = "large"
                        btncolor  = "#09c141"
                        height    = {38}
                        width     = {120}
                        isLoading = {this.state.isLoading}
                        text        = "Submit"
                        loadingText = ""
                        onClick     = {() => this.handleSubmit()}
                      />*/ }
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalAddBlockTemplate.js